module.exports = __webpack_public_path__ + "img/light_strip_pairing_mode.0b3adc5f.png";